import { Attribute } from ".";
import { ElementAttributeType, ElementType } from "../enums";

export class Element {
    public prototypeId: number = 0;

    public formContextId: number = 0;

    public parentFormContextId?: number;

    public formInputName?: string;

    public dynamicName?: string;

    public questionSummaryId?: number;

    public questionText?: string;

    public elementType: ElementType = 0;

    public attributes: Attribute<ElementAttributeType>[] = [];
}
